import React, { Component, Fragment } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { AppCard } from "../../../components/ui";
import "../issuing.scss";
import { Toast } from "primereact/toast";
import _ from "lodash";
import { FileText } from "lucide-react";

import { LoadingDots } from "../../../components/ui";
import { utils } from "../../../utils/utils";
import { issuingApiService } from "../../../services/api/Issuing/IssuingApiService";
import PageTitle from "../../../Layout/AppMain/PageTitle";
import { SettlementFileResponse } from "../../../models/IssuingClientsModel";
import moment from "moment";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";


interface ClientDetailsState {
    isLoading: boolean;
    fileDetails?: SettlementFileResponse | null;

    individualId?: number;

}

export default class FileDetailsComponent extends Component<Record<string, never>, ClientDetailsState> {
    toast: Toast | null = null;

    validationErrors: Map<string, boolean> = new Map<string, boolean>();

    constructor(props: Record<string, never>) {
        super(props);

        this.state = {
            isLoading: false,
            individualId: utils.getIdentifierFromPath(),
            fileDetails: null

        };
    }

    async getClientDetails() {
        if (this.state.individualId) {
            this.setState({ isLoading: true })
            const res = await issuingApiService.getFileDetails(this.state.individualId);
            if (res.success) {
                this.setState({
                    fileDetails: res.data,
                    isLoading: false
                })
            }
        }
    }
    componentDidMount(): void {
        this.getClientDetails();
    }


    updateValue = (fieldName: string, value: string) => {
        const merchantDetails = this.state.fileDetails as any;

        merchantDetails[fieldName] = value;

        this.setState({ fileDetails: merchantDetails });
    };

    renderReportBody = () => {
        if (this.state.isLoading || !this.state.fileDetails) {
            return (
                <AppCard>
                    <div className="flex items-center justify-center" style={{ minHeight: "500px" }}>
                        <LoadingDots />
                    </div>
                </AppCard>
            );
        }

        return (
            <AppCard>
                <AppCard.Body>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <div>
                            <strong>File Name:</strong> {this.state.fileDetails.file.fileName}
                        </div>
                        <div>
                            <strong>Import Date:</strong>{" "}
                            {new Date(this.state.fileDetails.file.importDt).toLocaleString()}
                        </div>
                        <div>
                            <strong>File Type:</strong> {this.state.fileDetails.fileType}
                        </div>
                    </div>
                </AppCard.Body>
            </AppCard>
        );
    };

    render() {
        return (
            <Fragment>
                <TransitionGroup component="div" appear={true} exit={false} enter={false}>
                    <CSSTransition classNames="TabsAnimation" timeout={1500}>
                        <PageTitle heading="File Details" icon={FileText} />
                    </CSSTransition>
                    <CSSTransition classNames="TabsAnimation" timeout={1500}>
                        <Fragment>
                            <Toast ref={(el) => (this.toast = el)} position={"bottom-center"} baseZIndex={99999}></Toast>
                            <div className="flex flex-col gap-4">
                                {this.renderReportBody()}

                                <AppCard>
                                    <AppCard.Header title="Settlement Details" />
                                    <AppCard.Body>
                                        <DataTable
                                            value={this.state?.fileDetails?.settlementDetails}
                                            responsiveLayout="scroll"
                                            emptyMessage="No settlement records found."
                                        >
                                            <Column field="id" header="ID" />
                                            <Column field="sftpImportFileId" header="Sftp ImportFileId" />
                                            <Column field="recordType" header="Record Type" />
                                            <Column field="settlementRequestId" header="Request ID" />
                                            <Column field="transactionId" header="Transaction ID" />
                                            <Column field="eventType" header="Event Type" />
                                            <Column
                                                field="settlementAmount"
                                                header="Amount"
                                                body={(row: any) => row.settlementAmount.toFixed(2)}
                                            />
                                            <Column field="settlementCurrency" header="Currency" />
                                            <Column
                                                field="settlementSign"
                                                header="Sign"
                                                body={(row: any) => (
                                                    <span
                                                        className={`badge ${row.settlementSign === "C" ? "badge-success" : "badge-danger"}`}
                                                    >
                                                        {row.settlementSign === "C" ? "Credit" : "Debit"}
                                                    </span>
                                                )}
                                            />
                                            <Column
                                                field="settlementDate"
                                                header="Settlement Date"
                                                body={(row: any) =>
                                                    moment.utc(row.settlementDate).local().format("DD/MM/YYYY HH:mm:ss")
                                                }
                                            />
                                            <Column field="cardId" header="Card ID" />
                                        </DataTable>
                                    </AppCard.Body>
                                </AppCard>
                            </div>
                        </Fragment>
                    </CSSTransition>
                </TransitionGroup>
            </Fragment>
        );
    }
}
